export default () => {
    return {
        coupons: [],
        coupons_summary: {}
    }
}
